import styled from '@emotion/styled'
import { Snackbar } from '@mui/material';
import useSnackbarStore from './index';

import { BasicFlex } from '../../utils/Common';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import NewReleasesRoundedIcon from '@mui/icons-material/NewReleasesRounded';

import { IconButton, Card, CardContent, useTheme } from '@mui/material';

const SnackbarCard = styled(BasicFlex)`
  padding: .5rem 1.5rem;
  padding-right: .5rem;
`

const SnackMessage = styled.div`
  max-width: 40rem;
  font-weight: 500;
  line-height: 1.5;
  padding: .2rem 2rem;
  padding-left: 1rem;
`

const FollowUpSnackbar = () => {
  const open = useSnackbarStore((state) => state.open);
  const hideSnackbar = useSnackbarStore((state) => state.hideSnackbar);
  const message = useSnackbarStore((state) => state.message);
  const repair_num = useSnackbarStore((state) => state.repair_num);
  const date = useSnackbarStore((state) => state.date);
  const customer_name = useSnackbarStore((state) => state.customer_name);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    hideSnackbar();
  };

  const theme = useTheme();

  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ top: '.5rem !important' }}
    >
    <Card elevation={6} sx={{backgroundColor: theme.palette.bg.light}}>
     <SnackbarCard gap="1.5rem">
      <NewReleasesRoundedIcon color="warning" />
      <SnackMessage>Follow up appointment for {customer_name}
        <br />
        On {date}
        <br />
        For repair Ticket #{repair_num}
      </SnackMessage>
      <IconButton onClick={handleClose}>
        <CloseRoundedIcon />
      </IconButton>
     </SnackbarCard>
    </Card>
    </Snackbar>
  );
};

export default FollowUpSnackbar;